import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
// eslint-disable-next-line import/no-unused-modules
export var UnionPath = styled.path(function (_a) {
    var negative = _a.negative, neutral = _a.neutral, colorScheme = _a.theme.colorScheme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fill: ", ";\n  "], ["\n    fill: ", ";\n  "])), function () {
        if (neutral) {
            if (negative) {
                return colorScheme === 'light' ? '#141414' : '#FFFFFF';
            }
            return colorScheme === 'light' ? '#FFFFFF' : '#141414';
        }
        return colorScheme === 'light' ? '#E01524' : '#EF5762';
    });
});
var templateObject_1;
//# sourceMappingURL=BeneficiosStandard.styles.js.map